<template>
    <div class="pl-message-item"
         :class="[`pl-message-item-color-${TYPE[type].color}`]" @click="pl_click">
        <div>
            <link-icon :icon="TYPE[type].icon" class="pl-message-item-icon"/>
            <span>{{message}}</span>
        </div>
        <div>
            <link-icon icon="link-icon-close" class="pl-message-item-close" @click.stop="close"/>
        </div>
    </div>
</template>

<script>

    export default {
        name: "pl-message-item",
        props: {
            message: {type: String},
            type: {type: String},
            time: {type: Number},
            done: {type: Function},
            click: {type: Function},
        },
        created() {
            if (this.time !== null) this.timer = setTimeout(() => {
                this.close()
                !!this.done && (this.done())
            }, this.time)
        },
        data() {
            return {
                TYPE: this.$lv.TYPE,
                timer: null,
            }
        },
        methods: {
            close() {
                this.$emit('done')
            },
            pl_click(e) {
                !!this.click && this.click(e)
            },
        },
    }
</script>
